import { QueryKeys } from "@/constants/query-keys";
import { useIsSubscriptionEnabled } from "@/hooks/use-is-subscription-enabled";
import { getCustomerInfo } from "@/utils/revenue-cat";
import { useQuery } from "@tanstack/react-query";

export const useCustomerInfo = () => {
  const { isEnabled } = useIsSubscriptionEnabled();
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.SUBSCRIPTION_CUSTOMER_INFO, isEnabled ? "enabled" : "disabled"],
    queryFn: () => getCustomerInfo(isEnabled),
    enabled: isEnabled,
    staleTime: 0,
  });

  return {
    customerInfo: data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
};
